var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNocomunication(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 190,
    viewBox: "0 0 150 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 190,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132,154.21a2.48,2.48,0,0,1-1.76-.73L16.26,40.06a2.5,2.5,0,1,1,3.52-3.54l114,113.42a2.5,2.5,0,0,1-1.77,4.27Z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.21,124.37a2.5,2.5,0,0,1-1.69-4.35c4.7-4.28,7.08-10,7.08-17.08A23.94,23.94,0,0,0,108.68,79a2.47,2.47,0,0,1-2.35-1.42A34.87,34.87,0,0,0,75,57.84,34.38,34.38,0,0,0,60.48,61a2.5,2.5,0,1,1-2.09-4.54A39.35,39.35,0,0,1,75,52.84,39.89,39.89,0,0,1,110.12,74a28.93,28.93,0,0,1,28.48,28.91c0,8.52-2.93,15.51-8.71,20.78A2.52,2.52,0,0,1,128.21,124.37Z",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.05,131.88c-1.17,0-11.06-.21-17.73-6.78-3.93-3.87-5.92-9.1-5.92-15.55a22.19,22.19,0,0,1,8.23-17.29,22.43,22.43,0,0,1,16.05-5,39.31,39.31,0,0,1,2.19-8.84,2.5,2.5,0,1,1,4.68,1.77,34,34,0,0,0-2.13,10.07,2.52,2.52,0,0,1-3,2.3,17.44,17.44,0,0,0-14.63,3.55,17.21,17.21,0,0,0-6.38,13.41c0,5.06,1.49,9.09,4.43,12,5.48,5.4,14.2,5.34,14.28,5.34H90.94a2.5,2.5,0,0,1,0,5H35.05Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNocomunication);
export default __webpack_public_path__ + "static/media/ic_nocomunication.33c3aba8805d209246e0aeea1f7817e3.svg";
export { ForwardRef as ReactComponent };